import { type SidebarBoxConfig, type StudentDashboardConfig } from 'AdmissionsGuidance/StudentDashboard.types';
import { memo, useEffect, useState } from 'react';
import { DesktopSidebarSkeleton } from './DesktopSidebarSkeleton';

type Props = {
    studentDashboardConfig: StudentDashboardConfig;
};

function DesktopSidebarComponent({ studentDashboardConfig }: Props) {
    const [boxConfigs, setBoxConfigs] = useState<SidebarBoxConfig[] | null>(null);

    useEffect(() => {
        studentDashboardConfig.desktopSidebarBoxes().then(desktopBoxConfigs => {
            const visibleBoxConfigs = desktopBoxConfigs.filter(
                boxConfig => !boxConfig.shouldHide && !!boxConfig.desktopContent,
            );
            setBoxConfigs(visibleBoxConfigs);
        });
    }, [studentDashboardConfig]);

    if (!boxConfigs) return <DesktopSidebarSkeleton />;

    return (
        <div data-testid="desktop-sidebar">
            {boxConfigs.map(boxConfig => (
                <div key={boxConfig.key} className="mb-7.5">
                    {boxConfig.desktopContent}
                </div>
            ))}
        </div>
    );
}

export const DesktopSidebar = memo(DesktopSidebarComponent) as typeof DesktopSidebarComponent;
